// RH — les heures, sous deux angles qui ne se confondent pas :
//
//   * le RELEVÉ : ce que chacun a fait de sa journée (arrivée, départ, pause),
//     tel que les équipes l'écrivent le soir. C'est ce qui part à la paie.
//   * le POINTAGE CHANTIER : la répartition de ces heures entre les chantiers,
//     qui sert au prix de revient.
//
// Les deux se nourrissent du même mois, choisi une fois pour toutes en haut.

import { useState } from 'react';

import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { PointagesChantierPanel } from '@/modules/rh/PointagesChantierPanel';
import { RelevesHeuresPanel } from '@/modules/rh/RelevesHeuresPanel';

type Onglet = 'releve' | 'pointage';

const ONGLETS: { id: Onglet; libelle: string }[] = [
  { id: 'releve', libelle: 'Relevé d’heures' },
  { id: 'pointage', libelle: 'Pointage chantier' },
];

export function RhPage() {
  const [mois, setMois] = useState(() => new Date().toISOString().slice(0, 7));
  const [onglet, setOnglet] = useState<Onglet>('releve');

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">RH — Heures</h1>
          <p className="text-muted-foreground">
            {onglet === 'releve'
              ? 'Les heures déclarées chaque jour par les équipes, et ce qui est dû.'
              : 'Répartition des heures par chantier, pour le prix de revient.'}
          </p>
        </div>
        <div className="space-y-1">
          <Label htmlFor="rh_mois">Mois</Label>
          <Input
            id="rh_mois"
            type="month"
            value={mois}
            onChange={(e) => {
              setMois(e.target.value);
            }}
            className="w-44"
          />
        </div>
      </div>

      <div className="flex gap-1 border-b">
        {ONGLETS.map((o) => (
          <button
            key={o.id}
            type="button"
            aria-current={onglet === o.id ? 'page' : undefined}
            className={`-mb-px border-b-2 px-4 py-2 text-sm font-medium transition-colors ${
              onglet === o.id
                ? 'border-primary text-foreground'
                : 'text-muted-foreground hover:text-foreground border-transparent'
            }`}
            onClick={() => {
              setOnglet(o.id);
            }}
          >
            {o.libelle}
          </button>
        ))}
      </div>

      {onglet === 'releve' ? (
        <RelevesHeuresPanel mois={mois} />
      ) : (
        <PointagesChantierPanel mois={mois} />
      )}
    </div>
  );
}
